import { Link } from 'react-router-dom';
import { TECHNICAL_RELATED_TOOLS } from '@/mocks/technical';
import { SectionHeading } from './ui';

export default function RelatedTools() {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Quy trình tiếp theo"
        title="Từ phân tích đến thực hiện lệnh"
      />

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {TECHNICAL_RELATED_TOOLS.map((t) => (
          <div key={t.title} className="group flex flex-col rounded-2xl border border-slate-200/80 bg-slate-50/50 p-5 transition-all hover:-translate-y-0.5">
            <div className="flex items-start justify-between">
              <span
                className="flex h-11 w-11 items-center justify-center rounded-xl"
                style={{ backgroundColor: `${t.accent}1a`, color: t.accent }}
              >
                <i className={`${t.icon} text-xl`} />
              </span>
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-violet-100 text-xs font-bold text-violet-700">
                {t.step}
              </span>
            </div>
            <p className="mt-3 text-sm font-bold text-slate-800">{t.title}</p>
            <p className="mt-1.5 text-xs leading-relaxed text-slate-500">{t.desc}</p>
            <p className="mt-3 flex items-start gap-1.5 text-xs font-medium leading-relaxed text-violet-700">
              <i className="ri-arrow-right-line mt-0.5 shrink-0" />
              <span>{t.flow}</span>
            </p>
            <Link
              to={t.to}
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-violet-600 transition-colors hover:text-violet-700"
            >
              Sử dụng công cụ
              <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}